import { render, staticRenderFns } from "./roleManager.vue?vue&type=template&id=2cc8a1d8&scoped=true&"
import script from "./roleManager.vue?vue&type=script&lang=js&"
export * from "./roleManager.vue?vue&type=script&lang=js&"
import style0 from "./roleManager.vue?vue&type=style&index=0&id=2cc8a1d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc8a1d8",
  null
  
)

export default component.exports